function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 44,
    viewBox: "0 0 47 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.79398 8.11534H1.81025C1.36276 8.11534 1 8.38635 1 8.72066V11.6899C1 12.0242 1.36276 12.2952 1.81025 12.2952H3.79398C4.24147 12.2952 4.60423 12.0242 4.60423 11.6899V8.72066C4.60423 8.38635 4.24147 8.11534 3.79398 8.11534Z",
    stroke: "#605D62",
    style: {
      stroke: "#605D62",
      stroke: "color(display-p3 0.3765 0.3647 0.3843)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9207 13.652L4.604 12.2953",
    stroke: "#605D62",
    style: {
      stroke: "#605D62",
      stroke: "color(display-p3 0.3765 0.3647 0.3843)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1533 8.11534H45.137C45.5845 8.11534 45.9473 8.38635 45.9473 8.72066V11.6899C45.9473 12.0242 45.5845 12.2952 45.137 12.2952H43.1533C42.7058 12.2952 42.343 12.0242 42.343 11.6899V8.72066C42.343 8.38635 42.7058 8.11534 43.1533 8.11534Z",
    stroke: "#605D62",
    style: {
      stroke: "#605D62",
      stroke: "color(display-p3 0.3765 0.3647 0.3843)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0266 13.652L42.3433 12.2953",
    stroke: "#605D62",
    style: {
      stroke: "#605D62",
      stroke: "color(display-p3 0.3765 0.3647 0.3843)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9367 19.0568H32.9267C33.2938 19.0568 33.5884 18.7792 33.5884 18.4427V11.1736C33.5884 10.8311 33.2938 10.5594 32.9267 10.5594H13.9448C13.645 10.5594 13.4072 10.837 13.4072 11.1736V18.4427C13.4072 18.7852 13.6502 19.0568 13.9448 19.0568H22.924",
    stroke: "#605D62",
    style: {
      stroke: "#605D62",
      stroke: "color(display-p3 0.3765 0.3647 0.3843)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8252 33.9272H17.1705C16.8488 33.9272 16.5938 33.6923 16.5938 33.4037V24.8911C16.5938 24.6025 16.8544 24.3677 17.1705 24.3677H29.8252C30.1468 24.3677 30.4019 24.6025 30.4019 24.8911V33.4037C30.4019 33.6923 30.1413 33.9272 29.8252 33.9272Z",
    stroke: "#605D62",
    style: {
      stroke: "#605D62",
      stroke: "color(display-p3 0.3765 0.3647 0.3843)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.086 28.3787C41.9377 25.6181 39.792 25.187 38.7642 25.1344C38.4728 25.1186 38.2503 24.8767 38.2503 24.5928L38.1443 1.54596C38.1443 1.14634 37.7205 0.883425 37.3549 1.05169L34.2715 2.48193C34.0755 2.57132 33.9536 2.76587 33.9536 2.98146V5.4055C33.9536 5.89452 33.3603 6.14165 33.0106 5.79461L31.6013 4.39592C31.5007 4.29602 31.3576 4.23817 31.2146 4.23292L23.2941 4.18033H23.7762L15.8558 4.23292C15.7127 4.23292 15.5697 4.29076 15.469 4.39592L14.0597 5.79461C13.7101 6.14165 13.1167 5.89452 13.1167 5.4055V2.98146C13.1167 2.76587 12.9949 2.57657 12.7988 2.48193L9.71542 1.05169C9.34986 0.883425 8.93132 1.14634 8.92602 1.54596L8.82006 24.5928C8.82006 24.882 8.59754 25.1239 8.30616 25.1344C7.28365 25.187 5.0585 25.6181 4.91016 28.3787V38.8631C4.91016 38.9881 5.06124 39.238 5.66559 39.238C6.26993 39.238 14.7308 39.238 18.8856 39.238H24.1737C29.5876 39.238 40.5665 39.238 41.1709 39.238C41.7752 39.238 42.0328 38.9881 42.086 38.8631V28.3787Z",
    stroke: "#605D62",
    style: {
      stroke: "#605D62",
      stroke: "color(display-p3 0.3765 0.3647 0.3843)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4109 29.1024H16.6719",
    stroke: "#605D62",
    style: {
      stroke: "#605D62",
      stroke: "color(display-p3 0.3765 0.3647 0.3843)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7637 39.238H8.76357C8.46375 39.238 8.2207 39.4811 8.2207 39.7809V42.4571C8.2207 42.7569 8.46375 43 8.76357 43H13.7637C14.0635 43 14.3065 42.7569 14.3065 42.4571V39.7809C14.3065 39.4811 14.0635 39.238 13.7637 39.238Z",
    stroke: "#605D62",
    style: {
      stroke: "#605D62",
      stroke: "color(display-p3 0.3765 0.3647 0.3843)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1069 39.238H33.1068C32.807 39.238 32.564 39.4811 32.564 39.7809V42.4571C32.564 42.7569 32.807 43 33.1068 43H38.1069C38.4067 43 38.6498 42.7569 38.6498 42.4571V39.7809C38.6498 39.4811 38.4067 39.238 38.1069 39.238Z",
    stroke: "#605D62",
    style: {
      stroke: "#605D62",
      stroke: "color(display-p3 0.3765 0.3647 0.3843)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8257,
    cy: 31,
    r: 2,
    fill: "#605D62",
    style: {
      fill: "#605D62",
      fill: "color(display-p3 0.3765 0.3647 0.3843)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.8257,
    cy: 31,
    r: 2,
    fill: "#605D62",
    style: {
      fill: "#605D62",
      fill: "color(display-p3 0.3765 0.3647 0.3843)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/truck-icon.2feb44efd4d6c47243037a5e692935b8.svg";
export { ForwardRef as ReactComponent };